
define(['jquery', 'underscore'], function($, _) {
  var isNearBottomOfPage, refreshSettings;
  isNearBottomOfPage = function() {
    return $(window).scrollTop() > 0 && $(window).scrollTop() > $(document).height() - $(window).height() - 200;
  };
  refreshSettings = function(container) {
    return container.data({
      isLoading: false,
      stopLoading: false,
      currentPage: 1
    });
  };
  return {
    init: function(callback, trigger, container) {
      if (trigger == null) {
        trigger = isNearBottomOfPage;
      }
      if (container == null) {
        container = $(window);
      }
      refreshSettings(container);
      return container.scroll(function() {
        var currentPage;
        if ($(this).data('isLoading') || !trigger()) {
          return;
        }
        currentPage = $(this).data('currentPage');
        currentPage++;
        $(this).data('currentPage', currentPage);
        $(this).data('isLoading', true);
        if (_.isFunction(callback)) {
          return callback(currentPage);
        }
      });
    },
    hide: function(container) {
      if (container == null) {
        container = $(window);
      }
      container.unbind('scroll');
      return refreshSettings(container);
    },
    refreshSettings: function(container) {
      if (container == null) {
        container = $(window);
      }
      return refreshSettings(container);
    },
    preventLoad: function(container) {
      if (container == null) {
        container = $(window);
      }
      return container.data('isLoading', true);
    },
    afterLoad: function(container) {
      if (container == null) {
        container = $(window);
      }
      return container.data('isLoading', false);
    },
    isStopLoading: function(container) {
      if (container == null) {
        container = $(window);
      }
      return container.data('stopLoading');
    },
    setStopLoading: function(status, container) {
      if (container == null) {
        container = $(window);
      }
      return container.data('stopLoading', status);
    }
  };
});
